(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[343],{

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 66604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    baseForOwn = __webpack_require__(47816),
    baseIteratee = __webpack_require__(67206);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 28951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ decodeGroupedAnalysis1; },
  "a": function() { return /* binding */ useGroupedAnalysis1; }
});

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/duration.ts
var duration = __webpack_require__(5964);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(23855);
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(66604);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
;// CONCATENATED MODULE: ./src/mainsite/api/burn-records.ts


const decodeBurnRecords = (rawBurnRecords)=>({
        ...rawBurnRecords,
        records: mapValues_default()(rawBurnRecords.records, (records)=>records.map((record)=>({
                    ...record,
                    minedAt: parseISO/* default */.Z(record.minedAt)
                })))
    });

// EXTERNAL MODULE: ./src/mainsite/api/fetchers.ts + 1 modules
var fetchers = __webpack_require__(78051);
;// CONCATENATED MODULE: ./src/mainsite/api/grouped-analysis-1.ts




const decodeGroupedAnalysis1 = (raw)=>raw === undefined ? undefined : {
        ...raw,
        burnRecords: decodeBurnRecords({
            number: raw.number,
            records: raw.burnRecords
        }).records
    };
const useGroupedAnalysis1 = ()=>{
    const { data  } = (0,dist/* default */.ZP)("/api/fees/grouped-analysis-1", fetchers/* fetchJsonSwr */.Ar, {
        refreshInterval: duration/* millisFromSeconds */.Io(4)
    });
    return data;
};


/***/ }),

/***/ 37343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "timeframeFeesBurnedMap": function() { return /* binding */ timeframeFeesBurnedMap; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89802);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17857);
/* harmony import */ var _assets_fire_own_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83915);
/* harmony import */ var _Amount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30772);
/* harmony import */ var _components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69443);
/* harmony import */ var _api_grouped_analysis_1__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28951);
/* harmony import */ var _TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62925);









const GWEI_FORMATTING_THRESHOLD = 1e15; // Threshold in wei below which to convert format as Gwei instead of ETH
const MIN_BURN_DECIMALS = 2;
const BURN_USD_DECIMALS = 0;
const timeframeFeesBurnedMap = {
    m5: {
        eth: "feesBurned5m",
        usd: "feesBurned5mUsd"
    },
    h1: {
        eth: "feesBurned1h",
        usd: "feesBurned1hUsd"
    },
    d1: {
        eth: "feesBurned24h",
        usd: "feesBurned24hUsd"
    },
    d7: {
        eth: "feesBurned7d",
        usd: "feesBurned7dUsd"
    },
    d30: {
        eth: "feesBurned30d",
        usd: "feesBurned30dUsd"
    },
    since_merge: {
        eth: "feesBurnedSinceMerge",
        usd: "feesBurnedSinceMergeUsd"
    },
    since_burn: {
        eth: "feesBurnedSinceBurn",
        usd: "feesBurnedSinceBurnUsd"
    }
};
function firstNonZeroDecimalPosition(num) {
    // If the number is >= 1, return 0
    if (num >= 1) {
        return 0;
    }
    // Convert the number to a string to inspect its decimal part
    const strNum = num.toFixed(20).toString();
    // Extract the decimal part by removing everything up to and including the decimal point
    const decimalPart = strNum.split(".")[1] || "";
    // Find the position of the first non-zero digit in the decimal part
    for(let i = 0; i < decimalPart.length; i++){
        if (decimalPart[i] !== "0") {
            // Return the position (i + 1 because position is 1-indexed in this context)
            return i + 1;
        }
    }
    // If there are no non-zero decimals (or the number is 0), it means all decimals are zero
    return decimalPart.length ? decimalPart.length : 0;
}
const BlobBurnWidget = (param)=>{
    let { onClickTimeFrame , timeFrame  } = param;
    const groupedAnalysis1F = (0,_api_grouped_analysis_1__WEBPACK_IMPORTED_MODULE_7__/* .useGroupedAnalysis1 */ .a)();
    const groupedAnalysis1 = (0,_api_grouped_analysis_1__WEBPACK_IMPORTED_MODULE_7__/* .decodeGroupedAnalysis1 */ .h)(groupedAnalysis1F);
    const feesBurned = groupedAnalysis1 === null || groupedAnalysis1 === void 0 ? void 0 : groupedAnalysis1.blobFeeBurns;
    const blobFeeBurn = feesBurned === undefined ? undefined : feesBurned[timeframeFeesBurnedMap[timeFrame]["eth"]];
    const blobFeeBurnUSD = feesBurned === undefined ? undefined : feesBurned[timeframeFeesBurnedMap[timeFrame]["usd"]];
    const formatBurnAsGwei = blobFeeBurn !== undefined && blobFeeBurn < GWEI_FORMATTING_THRESHOLD;
    const formattedBurn = blobFeeBurn !== undefined ? blobFeeBurn / (formatBurnAsGwei ? 1e9 : 1e18) : undefined;
    const burnDecimals = formattedBurn == undefined ? undefined : Math.max(firstNonZeroDecimalPosition(formattedBurn), MIN_BURN_DECIMALS);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_6__/* .WidgetBackground */ .K, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-y-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                children: "blob fee burn"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                timeFrame: timeFrame,
                                onClickTimeFrame: onClickTimeFrame
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mb-4 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Amount__WEBPACK_IMPORTED_MODULE_5__/* .AmountAnimatedShell */ .au, {
                                skeletonWidth: "9rem",
                                size: "text-2xl md:text-3xl lg:text-3xl xl:text-4xl",
                                unitText: formatBurnAsGwei ? "Gwei" : "ETH",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    decimals: burnDecimals,
                                    duration: 0.8,
                                    end: formattedBurn !== null && formattedBurn !== void 0 ? formattedBurn : 0,
                                    preserveValue: true,
                                    separator: ","
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ml-4 h-6 w-6 select-none md:ml-8 lg:h-8 lg:w-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    alt: "fire emoji symbolizing ETH burned",
                                    src: _assets_fire_own_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center gap-x-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-baseline gap-x-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Amount__WEBPACK_IMPORTED_MODULE_5__/* .AmountAnimatedShell */ .au, {
                        skeletonWidth: "2rem",
                        size: "text-m",
                        unitText: "USD",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            decimals: BURN_USD_DECIMALS,
                            duration: 0.8,
                            end: blobFeeBurnUSD !== null && blobFeeBurnUSD !== void 0 ? blobFeeBurnUSD : 0,
                            preserveValue: true,
                            separator: ","
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BlobBurnWidget);


/***/ })

}]);